<ag-shr-modal-window
  #associationModalRef
  [title]="associationModalTitle"
  [inProgress]="inProgress()"
  (onSaveClick)="handleSaveAssociation($event)"
  [onCloseModal]="handleAssociationFormPopupClose"
  [useScrollView]="false"
>
  @if (associationModalRef?.popupComponent?.visible ?? false) {
    <div class="associations__validation-summary ag-validation-summary" *ngIf="errors() as errors">
      @for (item of errors; track $index) {
        <dx-button
          class="ag-validation-summary__item"
          type="danger"
          stylingMode="outlined"
          [text]="item?.label | empty: 'Invalid field'"
          (onClick)="onValidationSummaryItemClick(item)"
        ></dx-button>
      }
    </div>

    <dx-tab-panel
      #associationsTabsRef
      [class.ag-profile-grid__tab-panel]="type === LayoutGridType.short"
      [dataSource]="tabsDataSource"
      width="100%"
      height="100%"
      [showNavButtons]="false"
      [stylingMode]="'primary'">
      <div *dxTemplate="let info of 'mainInfoItemTmp'" class="p-2">
        <ag-association-main-info-form
          [associationFormData]="associationFormData"
          [validationGroup]="mainInfoValidationGroup"
          [onGenderSelect]="onGenderSelect"
          [onRelationshipTypeSelectionChanged]="onRelationshipTypeSelectionChanged"
        ></ag-association-main-info-form>
      </div>

      <div *dxTemplate="let info of 'funStuffSizesItemTmp'" class="p-2">
        <ag-association-fun-stuff-sizes-form
          [associationFormData]="associationFormData"
          [validationGroup]="funStuffSizesValidationGroup"
          [type]="type"
        ></ag-association-fun-stuff-sizes-form>
      </div>

      <div *dxTemplate="let sizes of 'addressItemTmp'" class="p-2">
        <ag-association-address-form
          [associationFormData]="associationFormData"
          [validationGroup]="addressValidationGroup"
        ></ag-association-address-form>
      </div>

      <div *dxTemplate="let sizes of 'dietaryConsiderationsItemTmp'" class="p-2">
        <ag-shr-dietary-considerations-form
          [validationGroup]="dietaryConsiderationsValidationGroup"
          [dietaryConsiderations]="associationFormData?.[AssociationKeys.dietaryConsideration]"
        ></ag-shr-dietary-considerations-form>
      </div>

      <div *dxTemplate="let flightPreference of 'flightPreferenceItemTmp'" class="p-2">
        <ag-shr-flight-preference-form
          [type]="type"
          [validationGroup]="flightPreferenceValidationGroup"
          [flightPreference]="associationFormData?.[AssociationKeys.flightPreference]"
        ></ag-shr-flight-preference-form>
      </div>
    </dx-tab-panel>
  }
</ag-shr-modal-window>

<div class="mt-2">
  <ng-container *ngTemplateOutlet="grid; context: { type: type }"></ng-container>
</div>

<ng-template #grid let-type="type">
  <dx-data-grid
    #associationsDataGridRef
    *var="inEditMode() as inEditMode"
    class="associations__data-grid"
    [ngClass]="{ 'associations__data-grid--view': !inEditMode, 'ag-profile-grid__grid': LayoutGridType.default !== type }"
    [dataSource]="associations()"
    [keyExpr]="BaseModelKeys.dbId"
    [showRowLines]="LayoutGridType.default === type"
    [showBorders]="LayoutGridType.default === type"
    [showColumnLines]="LayoutGridType.default === type"
    [showColumnHeaders]="LayoutGridType.default === type"
    [columnAutoWidth]="false"
    [wordWrapEnabled]="inEditMode"
    [rowAlternationEnabled]="false"
    [columnHidingEnabled]="true"
    [noDataText]="emptyMessage"
    (onRowRemoving)="onRowRemoving($event)"
    height="100%"
  >
    <dxo-toolbar>
      <dxi-item location="before">
        <div *dxTemplate>
          <div class="toolbar-label">
            <b>{{ gridTitle }}</b>
          </div>
        </div>
      </dxi-item>

      @if (hasPermissionsToEdit) {
        <dxi-item
          [visible]="!inEditMode"
          location="after"
          widget="dxButton"
          locateInMenu="auto"
          [cssClass]="'ag-profile-grid__toolbar-button'"
        >
          <div *dxTemplate>
            <dx-button
              hint="ENABLE EDIT"
              icon="edit"
              stylingMode="text"
              [agMergeGuard]="agentDbId"
              (agMergeGuardedClick)="enableEditMode()"
            ></dx-button>
          </div>
        </dxi-item>

        <dxi-item
          [visible]="inEditMode"
          location="after"
          widget="dxButton"
          locateInMenu="auto"
          [cssClass]="'ag-profile-grid__toolbar-button'"
        >
          <div *dxTemplate>
            <dx-button
              hint="CANCEL EDIT"
              icon="undo"
              type="danger"
              stylingMode="text"
              (onClick)="disableEditMode()"
            ></dx-button>
          </div>
        </dxi-item>
      }

      @if (inEditMode && hasPermissionsToAdd) {
        <dxi-item
          location="after"
          widget="dxButton"
          [cssClass]="type !== LayoutGridType.default ? 'ag-profile-grid__toolbar-button' : ''"
        >
          <div *dxTemplate>
            <dx-button
              icon="plus"
              [stylingMode]="type !== LayoutGridType.default ? 'text' : 'outlined'"
              [agMergeGuard]="agentDbId"
              (agMergeGuardedClick)="showAddAssociationPopup()"
            ></dx-button>
          </div>
        </dxi-item>
      }
    </dxo-toolbar>

    <dxo-editing
      mode="popup"
      [useIcons]="true"
      [allowUpdating]="false"
      [allowDeleting]="hasPermissionsToDelete"
      [allowAdding]="false"
    >
    </dxo-editing>

    <dxo-paging [enabled]="false"></dxo-paging>
    <dxo-scrolling [mode]="'virtual'" [showScrollbar]="'always'"></dxo-scrolling>

    <dxi-column
      [visible]="LayoutGridType.short === type"
      [name]="'fullAssociations'"
      [caption]="''"
      [calculateDisplayValue]="calculateFullAssociationsDisplayValue"
      cellTemplate="fullAssociationsCellTemplate"
      [width]="LayoutGridType.short === type ? '80%' : '50%'"
    >
      <div *dxTemplate="let cell of 'fullAssociationsCellTemplate'">
        <p class="mb-0 fs-6 fw-bold">
          {{ cell?.displayValue?.fullName }}
          <i
            *ngIf="cell?.displayValue?.isEmergencyContact"
            class="dx-icon dx-icon-agi-asterisk associations__data-grid__emergency-symbol ms-2"
            [title]="'Emergecy Contact'"></i>
        </p>
        <p
          class="mb-0">{{ cell?.displayValue?.associationType | lookupDescription : Lookups.AssociationType | async }}</p>
      </div>
    </dxi-column>

    <dxi-column
      caption="Name"
      [calculateDisplayValue]="calculateFullAssociationsDisplayValue"
      [visible]="LayoutGridType.short !== type"
      [allowHiding]="false"
      cellTemplate="nameCellTemplate"
    >
      <div *dxTemplate="let cell of 'nameCellTemplate'">
        <p class="mb-0">
          {{ cell?.displayValue?.fullName }}
          <i
            *ngIf="cell?.displayValue?.isEmergencyContact"
            class="dx-icon dx-icon-agi-asterisk associations__data-grid__emergency-symbol ms-2"
            [title]="'Emergecy Contact'"></i>
        </p>
      </div>
    </dxi-column>

    <dxi-column
      [dataField]="AssociationKeys.emailAddress" [allowHiding]="false" caption="Email Address"
      [visible]="LayoutGridType.short !== type"
    ></dxi-column>

    <dxi-column
      [dataField]="AssociationKeys.contactNumber"
      [visible]="LayoutGridType.short !== type"
      [allowHiding]="false"
      [width]="150"
      caption="Number"
      [calculateDisplayValue]="calculateContactNumberDisplayValue"
    ></dxi-column>

    <dxi-column
      [dataField]="AssociationKeys.associationType"
      caption="Relationship"
      [visible]="LayoutGridType.short !== type"
    >
      <dxo-lookup
        [dataSource]="relationshipTypeLookup()"
        [valueExpr]="BaseModelKeys.dbId"
        [displayExpr]="LookupKeys.description"
      ></dxo-lookup>
    </dxi-column>

    <dxi-column
      [dataField]="AssociationKeys.dob"
      [visible]="LayoutGridType.short !== type"
      [caption]="'Date Of Birth'"
      [allowHiding]="true"
      [hidingPriority]="4"
      dataType="date"
      [format]="dateFormat"
    ></dxi-column>

    <dxi-column
      [dataField]="AssociationKeys.gender"
      [visible]="LayoutGridType.short !== type"
      [caption]="'Gender'"
      [allowHiding]="true"
      [hidingPriority]="5"
      cellTemplate="genderCellTemplate"
    ></dxi-column>
    <div *dxTemplate="let cell of 'genderCellTemplate'" class="associations__address-container">
      {{ cell?.data?.gender | gender | async }}
    </div>

    <dxi-column
      [visible]="LayoutGridType.short !== type"
      [width]="150"
      cellTemplate="tShirtSizeCellTemplate"
      [caption]="'T-Shirt Size'"
      [allowHiding]="true"
      [hidingPriority]="2"
    ></dxi-column>
    <div *dxTemplate="let cell of 'tShirtSizeCellTemplate'" class="associations__address-container">
      {{ cell?.data?.[AssociationKeys.tShirtSizes]?.[TShirtSizesKeys?.unisextShirtSize] | tShirtSize | async }}
    </div>

    <dxi-column
      [visible]="LayoutGridType.short !== type"
      [width]="150"
      cellTemplate="shirtSizeCellTemplate"
      [caption]="'Shirt Size'"
      [allowHiding]="true"
      [hidingPriority]="3"
    ></dxi-column>
    <div *dxTemplate="let cell of 'shirtSizeCellTemplate'" class="associations__address-container">
      {{ cell?.data?.[AssociationKeys.tShirtSizes]?.[TShirtSizesKeys?.genderTShirtSize] | tShirtSize | async }}
    </div>

    <dxi-column
      [visible]="LayoutGridType.short !== type"
      [dataField]="AssociationKeys.address"
      cellTemplate="addressCellTemplate"
      [caption]="'Address'"
      [allowHiding]="true"
      [hidingPriority]="7"
    ></dxi-column>
    <div
      *dxTemplate="let data of 'addressCellTemplate'"
      title="{{ data.displayValue | fullAddress }}"
      class="associations__address-container"
    >
      {{ data.displayValue | fullAddress }}
    </div>

    <dxi-column
      [visible]="LayoutGridType.short !== type"
      cellTemplate="considerationCellTemplate"
      [caption]="'Consideration(s)'"
      [allowHiding]="true"
      [hidingPriority]="6"
    ></dxi-column>
    <div *dxTemplate="let cell of 'considerationCellTemplate'" class="associations__address-container">
      {{ cell?.data?.[AssociationKeys.dietaryConsideration]?.[DietaryConsiderationKeys.dietaryConsiderationType] | dietaryConsiderationType | async }}
      <span
        *ngIf="cell?.data?.[AssociationKeys.dietaryConsideration]?.[DietaryConsiderationKeys.dietaryConsideration] as consideration"
      >/ {{ consideration }}</span
      >
    </div>

    <dxi-column type="buttons" [visible]="inEditMode" [width]="LayoutGridType.default !== type ? '60px' : undefined">
      <dxi-button
        icon="edit"
        [cssClass]="'ag-profile-grid__col-button'"
        [visible]="hasPermissionsToEdit"
        [onClick]="showEditPopup"
      ></dxi-button>
      <dxi-button
        name="delete"
        icon="trash"
        [cssClass]="'ag-profile-grid__col-button'"
        [visible]="hasPermissionsToDelete"
      ></dxi-button>
    </dxi-column>
  </dx-data-grid>
</ng-template>
